import { render, staticRenderFns } from "./vipcenter.vue?vue&type=template&id=192df15e&scoped=true&"
import script from "./vipcenter.vue?vue&type=script&lang=ts&"
export * from "./vipcenter.vue?vue&type=script&lang=ts&"
import style0 from "./vipCenter.scss?vue&type=style&index=0&id=192df15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192df15e",
  null
  
)

export default component.exports